module.exports = __webpack_public_path__ + "static/media/malphos_1000ce.b18799dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/manzano/climasense/palomilla_manzano/curativa/malphos_1000ce.png
// module id = 1748
// module chunks = 3